
// inside your component
import { useAdminAdviserMails } from "../../../context/AdminAdviserEmailsContext";
import { useState, useEffect } from "react";
import { ReactComponent as CloseIcon } from "../../../assets/icons/close.svg";
import ButtonSmall from "./../Buttons/ButtonSmall";
import "../../../css/Components/Sidebar/Sidebar.css";

export const SwitchAdviserModal = ({ isModalOpen, setIsModalOpen, onConfirm }) => {
  const {
    adminAdviserMails,
    currentAdviserEmail,
    setCurrentAdviser,
  } = useAdminAdviserMails();

  // Stage selection locally
  const [stagedEmail, setStagedEmail] = useState(currentAdviserEmail);

  useEffect(() => {
    // When modal opens, sync staged value with current
    if (isModalOpen) setStagedEmail(currentAdviserEmail);
  }, [isModalOpen, currentAdviserEmail]);

  if (!isModalOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <CloseIcon className="ModalCloseButton" onClick={() => setIsModalOpen(false)} />
        <h4>Switch Adviser</h4>

        <div className="dropdown-container">
          <select
            className="Content"
            value={stagedEmail}
            onChange={(e) => setStagedEmail(e.target.value)}
          >
            {adminAdviserMails.map((email) => (
              <option key={email} value={email}>
                {email}
              </option>
            ))}
          </select>
        </div>

        <ButtonSmall
          buttonText="Confirm"
          onClick={() => {
            setCurrentAdviser(stagedEmail);       // persist & make it current
            setIsModalOpen(false);
          }}
        />
      </div>
    </div>
  );
};
